/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Outlook_No_SpacesInputs */



/**
* | output |
* | --- |
* | "Connect an Outlook mailbox under Spaces first, then enable it here." |
*
* @param {Connections_Outlook_No_SpacesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_outlook_no_spaces = /** @type {((inputs?: Connections_Outlook_No_SpacesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Outlook_No_SpacesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbinden Sie zuerst ein Outlook-Postfach unter „Bereiche“, dann können Sie es hier aktivieren.")
	return /** @type {LocalizedString} */ ("Connect an Outlook mailbox under Spaces first, then enable it here.")
});